<!--
 * @Author: your name
 * @Date: 2021-06-26 16:38:14
 * @LastEditTime: 2026-07-24 17:59:35
 * @LastEditors: YangHan 1047143112@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \kares_pad\src\components\schedule\windows\children\ToolsList\ToolTimewait.vue
-->
<!--正计时-->

<template>
  <div class="tool-timewait ellipsis-1" :class="{ 'multi-line': !media.ext_val_singleLine }" :style="eleStyle">
    <span>{{ media.ext_val_text }}</span>
    <span v-show="media.ext_val_showDay">{{ times.day }}{{ media.ext_val_style === 0 ?
      ':' : $t('PE.Day') }}</span>
    <span v-show="media.ext_val_showHour">{{ formatting(times.hh) }}{{ media.ext_val_style === 0 ?
      ':' : $t('PE.Hour') }}</span>
    <span v-show="media.ext_val_showMinute">{{ formatting(times.mm) }}{{ media.ext_val_style === 0 ?
      ':' : $t('PE.Minutes') }}</span>
    <span :class="{ 'after-placeholder': media.ext_val_style === 0 }" v-show="media.ext_val_showSecond">{{
      formatting(times.ms) }}{{ media.ext_val_style === 0 ?
        '' : $t('PE.Second') }}</span>
  </div>
</template>

<script>
import { formatting } from "@/assets/scripts/dateFormatting";
export default {
  name: "ToolTimewait",
  props: {
    media: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      formatting,
      times: {
        day: 0,
        hh: 0,
        mm: 0,
        ms: 0,
      },
      timeStatus: {
        startTime: 0,
        endTime: 0,
        timer: 0,
      }
    }
  },
  mounted() {
    // this.timeInit();
  },
  methods: {
    relativeTimeInit() {
      this.timeStatus.startTime = new Date().getTime();
      this.timeStatus.timer = this.timeStatus.startTime;
      this.timeStatus.endTime = new Date().getTime() + this.media.ext_val_relativeTime * 1000;
      this.timeRun();
    },
    absoluteTimeInit() {
      this.timeStatus.startTime = new Date().getTime();
      this.timeStatus.timer = this.timeStatus.startTime;
      this.timeStatus.endTime = parseInt(this.media.ext_val_absoluteTime.getTime());
      this.timeRun();
    },
    timeRun() {
      let run = () => {
        this.timeStatus.timer = new Date().getTime();
        if (this.timeStatus.timer < this.timeStatus.endTime) {
          this.timeFormatting(this.timeStatus.timer - this.timeStatus.startTime);
          requestAnimationFrame(run);
        }

      }
      requestAnimationFrame(run);
    },
    timeFormatting(time) {
      let ms = Math.ceil(parseInt(time) / 1000) * 1000;
      let D = Math.floor(ms / 1000 / 60 / 60 / 24);
      let H = Math.floor(ms / 1000 / 60 / 60) % 24;
      let M = Math.floor(ms / 1000 / 60) % 60;
      let S = Math.ceil(ms / 1000) % 60;
      this.times = { day: D, hh: formatting(H), mm: formatting(M), ms: formatting(S), };
    }
  },
  computed: {
    eleStyle() {
      return {
        'font-size': this.media.ext_val_textSize * 1 * this.ratio * 1.30 + 'px',
        'font-family': this.media.ext_val_family,
        'background': this.media.ext_val_backgroundColor,
        'color': this.media.ext_val_textColor
      }
    },
    ratio() {
      return this.$store.state.program.ratio;
    }
  },
  watch: {
    'media.ext_val_relativeTime': {
      handler() {
        this.media.ext_val_isRelativeTime && this.relativeTimeInit();
      },
      immediate: true
    },
    'media.ext_val_absoluteTime': {
      handler() {
        !(this.media.ext_val_isRelativeTime) && this.absoluteTimeInit();
      },
      immediate: true
    },
  }
}
</script>

<style lang="scss" scoped>
.tool-timewait {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  user-select: none;
  color: #fff;

  .after-placeholder::after {
    content: ":";
    color: rgba(255, 255, 255, 0);
  }
}

.multi-line {
  flex-direction: column;
}
</style>